import {
  CheckOutlined,
  CloseOutlined,
  EditOutlined,
  EyeOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import { Button, Collapse, Input, Modal, Switch } from "antd";
import React, { useEffect, useState } from "react";
import Category from "./Category";
import { changeShopInfo } from "../../../service/shopApi";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import ExpertProducts from "./ExpertProducts";
import { getStaticExpertFields } from "../../../service/api";

export default function ShopComponent({ shopData }) {
  const queryCilent = useQueryClient();
  const expertStaticsQuery = useQuery(["staticsExpertFields"], getStaticExpertFields);
  const changeMutation = useMutation(changeShopInfo, {
    onSuccess: () => {
      setOpenModal(false);
      return queryCilent.invalidateQueries({
        queryKey: ["expertShop"],
      });
    },
  });
  const [collapseColor, setCollapseColor] = useState();
  const [checked, setChecked] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState();
  const [newCategory, setNewCategory] = useState();
  const [newGoods, setNewGoods] = useState();
  const [openColapseKey, setOpenColapseKey] = useState();

  const profile = JSON.parse(localStorage.getItem("profile"));
const expertStaticsShop = expertStaticsQuery?.data?.EXPERT_SHOP_CATEGORIES
  let w = window.innerWidth;
  useEffect(() => {
    shopData?.shopStatus === "ACTIVE" ? setChecked(true) : setChecked(false);
  }, [shopData?.shopStatus]);
  useEffect(() => {
    if (shopData?.categories?.length === 0) {
      setNewCategory(true);
    } else {
      setNewCategory(false);
    }
  }, [shopData?.categories?.length]);

  const items = shopData?.categories?.map((data) => {
    return {
      key: data?.typeId,
      label: data?.title,
      children: (
        <ExpertProducts shopData={data} setCollapseColor={setCollapseColor} />
      ),
    };
  });
  useEffect(() => {
    if (items) {
      setOpenColapseKey(items[0]?.key);
    }
  }, [items, openColapseKey]);
  return (
    <div className="bg-white flex flex-col gap-8 max-lg:gap-2 font-body rounded-md shadow-md  pt-10 pb-3">
      <section className="flex flex-row items-center max-lg:flex-wrap gap-x-2 justify-between  px-3">
        <h2 className="  text-3xl hidden mb-2 max-lg:block w-full whitespace-nowrap text-[#005AC8]">
          فروشگاه من
        </h2>
        <div className="flex felx-row max-lg:flex-col gap-1 text-xs ">
          <p className="text-[#005AC8] whitespace-nowrap max-lg:flex-row max-lg:whitespace-nowrap">
            شماره تماس فروشگاه:
          </p>
          <div className="flex flex-row mx-auto">
            <p>{shopData?.shopPhoneNumber}</p>
            <EditOutlined
              className="cursor-pointer"
              onClick={() =>
                openModal === true ? setOpenModal(false) : setOpenModal(true)
              }
            />
          </div>
        </div>
        <h2 className="  max-lg:hidden text-3xl w-full whitespace-nowrap text-[#005AC8]">
          فروشگاه من
        </h2>

        <div className="flex flex-col gap-2 ">
          <Button
            href={`https://agroiranexpert.com/${profile?.username}`}
            target="_blank"
            className="items-center bg-[#005AC8] rounded-xl max-lg:text-[10px] text-white"
            icon={<EyeOutlined />}
          >
            مشاهده در صفحه
          </Button>

          <div className="flex flex-row m-auto gap-2 max-lg:text-[10px] ">
            <p className={checked ? "text-gray-400" : "text-[#E10000]"}>
              غیر فعال
            </p>
            <Switch
              disabled={!["ACTIVE", "INACTIVE"].includes(shopData?.shopStatus)}
              className="bg-red-300 active:bg-green-400 "
              checked={checked}
              size={w >= 1024 ? "default" : "small"}
              onChange={(e) => {
                setChecked(e);
                changeMutation.mutate({ active: e });
              }}
            />
            <p className={checked ? "text-[#008B45]" : "text-gray-400"}>فعال</p>
          </div>
        </div>
      </section>
      <section className="flex flex-col gap-8 px-3 max-lg:text-[11px] max-lg:my-4">
        <p>
          میتوانید انواع مختلف محصولات را در دسته‌های مشخصی دسته‌بندی کنید. به
          طور مثال کودها را در دسته‌بندی کودهای کشاورزی قرار دهید.
        </p>

        <div
          className="flex flex-row m-auto text-2xl gap-2 "
          onClick={() => setNewGoods(true)}
        >
          <p>افزودن دسته‌بندی جدید</p>
          <PlusCircleOutlined className="text-4xl text-gray-400 cursor-pointer hover:text-blue-400" />
        </div>
      </section>
      <section>
        {newCategory === true || newGoods === true ? (
          <Category
            shopData={shopData}
            setNewCategory={setNewCategory}
            setNewGoods={setNewGoods}
          />
        ) : null}{" "}
      </section>
      <section>
        <Modal
          closable={false}
          centered
          okButtonProps={{ hidden: true }}
          cancelButtonProps={{ hidden: true }}
          bodyStyle={{ padding: "0px", marginTop: "12px" }}
          onCancel={() => setOpenModal(false)}
          open={openModal}
        >
          <div className="!font-body mx-[-1rem] my-[-1.4rem] border-2 p-5 rounded-md flex flex-col items-center gap-8 ">
            <p className="text-xl text-center">
              لطفا شماره موبایل خود را وارد کنید
            </p>
            <Input
              dir="ltr"
              onChange={(e) => setPhoneNumber(e.target.value)}
              type={phoneNumber?.length >= 11 ? "text" : "number"}
              maxLength={11}
              className="w-[70%] text-xl text-center"
              placeholder="مثال: 09121122333"
            />
            <div className="text-left flex flex-row gap-2">
              <Button
                icon={<CloseOutlined />}
                type="primary"
                className="w-[171px] !rounded-full"
                onClick={() => setOpenModal(false)}
                danger
              >
                لغو
              </Button>
              <Button
                icon={<CheckOutlined />}
                className="w-[171px] !rounded-full bg-[#005AC8]"
                type="primary"
                onClick={() => {
                  changeMutation.mutate({
                    phoneNumber: phoneNumber,
                  });
                }}
              >
                تایید
              </Button>
            </div>
          </div>
        </Modal>
      </section>
      <section className=" flex flex-col ">
        {/* {
          <Collapse
            expandIconPosition="end"
            className={`!color4 text-right`}
            items={items}
          />
        } */}
        <Collapse className=" flex flex-col gap-4  "  expandIconPosition="end">
          {shopData?.categories?.map((item) => {
            let dataObject = expertStaticsShop.find((data)=> data.id === item.typeId)
            return (
              <Collapse.Panel
              
                key={item?.typeId}
                className={`color${item?.themeId} text-right text-white`}
                header={dataObject?.title}
              >
                <ExpertProducts
                
                dataObject={dataObject}
                  shopData={item}
                  setCollapseColor={setCollapseColor}
                />
              </Collapse.Panel>
            );
          })}
        </Collapse>
      </section>
    </div>
  );
}
